import { CreatePaymentErrorResponseErrorCode } from '@/api/api.schemas';
import { TranslationKey } from '@/contexts/translations';
import { BluefinInvalidInputError } from '@/types/payconex';
import uniq from 'lodash/uniq';

const translationBaseIFrameError = 'visit.payment.iFrameErrors';
const translationBasePaymentError = 'visit.payment.paymentErrors';

export function getErrorMessages(errors: BluefinInvalidInputError) {
  const errorMessages = errors.invalidInputs.map((error) => {
    switch (error.code) {
      case 1000:
        return `${translationBaseIFrameError}.blankInput`;
      case 1001:
        if (error.field === 'cvv') {
          return `${translationBaseIFrameError}.inputTooShortCVV`;
        }
        return `${translationBaseIFrameError}.inputTooShortCard`;
      case 1002:
        return `${translationBaseIFrameError}.inputTooLong`;
      case 1003:
        return `${translationBaseIFrameError}.inputNotNumeric`;
      case 1004:
        return `${translationBaseIFrameError}.invalidCardNumber`;
      case 1005:
        return `${translationBaseIFrameError}.invalidExpiryDate`;
      default:
        return `${translationBaseIFrameError}.default`;
    }
  });

  return uniq(errorMessages);
}

export function getUserFriendlyErrorMessage(
  errorCode?: CreatePaymentErrorResponseErrorCode,
): TranslationKey {
  if (!errorCode) {
    return `${translationBasePaymentError}.GenericError`;
  }

  return `${translationBasePaymentError}.${errorCode}`;
}
